// src/store/slices/ui.slice.js

import { createSlice } from '@reduxjs/toolkit'

/* ---------------------------------------------------------- */
/* ---------------------- Initial State --------------------- */
/* ---------------------------------------------------------- */

const initialState = {
  showNotRegisteredPopup: false,
  showLogin: false,
  showSignUp: false,
}

/* ---------------------------------------------------------- */
/* ------------------------ Slice --------------------------- */
/* ---------------------------------------------------------- */

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    openNotRegisteredPopup(state) {
      state.showNotRegisteredPopup = true
    },
    closeNotRegisteredPopup(state) {
      state.showNotRegisteredPopup = false
    },
    openLogin(state) {
      state.showLogin = true
    },
    closeLogin(state) {
      state.showLogin = false
    },
    openSignUp(state) {
      state.showSignUp = true
    },
    closeSignUp(state) {
      state.showSignUp = false
    },
  },
})

/* ---------------------------------------------------------- */
/* ---------------------- Exports --------------------------- */
/* ---------------------------------------------------------- */

export const {
  openNotRegisteredPopup,
  closeNotRegisteredPopup,
  openLogin,
  closeLogin,
  openSignUp,
  closeSignUp,
} = uiSlice.actions

export const uiReducer = uiSlice.reducer
